import { Grid } from "@mui-wrapper";
import { ErrorWithTitle } from "@components/error-boundary/error-types";
import { getErrorDisplayMarkup } from "@components/error-boundary/error-boundary-utils";
import { Warning } from "@mui/icons-material";
import { SanitizedHtmlTag } from "@components/sanitized-html-tag";
import { Button, Text } from "@flat-ui";

interface Props {
  /** An error with user readable text and actual error */
  error: ErrorWithTitle;

  /** Callback when Reload button is clicked */
  onReload?(): void;

  /** Callback when Home button is clicked */
  onGoHome?(): void;
}

/** Displays an error message with stack trace and a reload button. */
export function ErrorPage({
  error,
  onReload,
  onGoHome,
}: Props): React.JSX.Element {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        maxWidth: "500px",
        ml: "50%",
        transform: "translateX(-50%)",
        mt: "50px",
        flexDirection: "column",
        justifyContent: "space-around",
      }}
    >
      <Grid container sx={{ alignItems: "center" }}>
        <Warning sx={{ mr: "10px" }} />
        <Text variant="heading20">{error.title}</Text>
      </Grid>

      <Grid>
        <SanitizedHtmlTag markup={getErrorDisplayMarkup(error.error)} />
      </Grid>

      <Grid
        sx={{
          alignSelf: "flex-end",
          "& Button": {
            ml: "8px",
          },
        }}
      >
        <Button onClick={onGoHome}>Home</Button>
        <Button onClick={onReload}>Reload</Button>
      </Grid>
    </Grid>
  );
}
